//@ts-ignore
import uuid from "react-uuid"
const normalizeReferenceData = {
    /* A function that takes two parameters, data and pointer. It then loops through the data and pushes
    the id and text to the normalized array. It then returns the normalized array and the original keys. */
    normalize: (data: Array<any>, pointer: Array<string>, order?: "asc" | "desc") => {
        let normalized: Array<{ id: number, text: number, hashKey: string }> = []
        for (let i = 0; i < data.length; i++) {
            normalized.push({ id: data[i][pointer[0]], text: data[i][pointer[1]], hashKey: `${i}_${uuid()}` })
        }
        const result = {
            normalized: order ?
                (order === "asc" ?
                    normalized.sort(function (a, b) { return (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0); })
                    :
                    normalized.sort(function (a, b) { return (b.text > a.text) ? 1 : ((a.text > b.text) ? -1 : 0); }))
                :
                normalized,
            orinalKeys: [pointer[0], pointer[1]]
        }
        return result
    }
}
export default normalizeReferenceData